import styled from 'styled-components';

export const StyledCpscFormDiv = styled.div`
  .ant-input-number {
    width: 100%;
  }
`;
